/*
  this is the "head" entry point for webpack
  files imported here are compiled into head.js or head.css
  see webpack.config.js for configuration
*/

// VENDOR STUFF
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
import * as Cookies from 'js-cookie';
window.Cookies = Cookies;
import 'bootstrap';

// OUR STUFF
window.idx = {};
